/**
 * This module's route paths as constants, so no client ever writes a URL as a
 * string. Same rule as `../iam/routes.ts` and `../catalog/routes.ts`: a typo in
 * a path is otherwise a 404 discovered at runtime, and here it does not
 * compile.
 *
 * Each key is ONE path with every method it answers, rather than one key per
 * verb — naming them separately would suggest two resources where there is one.
 *
 * ── THE NAME IS `DEVICE_ROUTES` AND IT NOW CARRIES A NON-DEVICE ROUTE ───────
 * `preferences` is not about a device; it is about a person (`D116`). It lives
 * in this table anyway, and the table keeps its name, because
 * `apps/api/src/__tests__/pool/route-reachability.test.ts` asserts that the
 * contract declares exactly FOUR route tables — the check that makes the whole
 * reachability sweep non-vacuous by proving it still sees every table there is.
 * A fifth table here would fail it; a RENAME would touch every importer for no
 * behavioural gain. So: one more key, same object, this comment as the reason.
 * The day this table grows a third unrelated key, rename it and update that
 * count deliberately, in one commit, rather than discovering the constraint
 * from a red test.
 */
export const DEVICE_ROUTES = {
    /**
     * `POST /me/devices` → `204`, `DELETE /me/devices` → `204`.
     *
     * Idempotent both ways: registering a known token refreshes it, deleting an
     * unknown one succeeds.
     */
    devices: "/me/devices",
    /**
     * `GET /me/notification-preferences` → `notificationPreferencesOutput`,
     * `PUT` the same path with `notificationPreferences` → the same output
     * (`D116`).
     *
     * `GET` never 404s: an account that has never written one reads the
     * defaults — reminder off, soreness and summary on, offset 0 — without a row
     * existing. A client that had to distinguish "no preferences" from "these
     * preferences" would be distinguishing nothing a person can see.
     */
    preferences: "/me/notification-preferences",
};
//# sourceMappingURL=routes.js.map